<template>
  <button class="mb" type="button" @click="showForm">
    Рассчитать стоимость <IconArrowRight />
  </button>
  <Teleport to="body" v-if="show">
    <ModalZakazForm @closed="show = false" />
  </Teleport>
</template>

<script setup>
const { isModal } = useModal();
const show = ref();
const showForm = () => {
  if (!isModal) return navigateTo({ path: "/_modal", query: { zakaz: true } });
  show.value = true;
};
</script>
